import type {DefaultOptions} from '../../../types';
import type {MultipleAcceptableValueEditorLocalizations, MultipleAcceptableValueEditorOptions} from './types';
import DefaultOptionLabel from '../_shared/DefaultOptionLabel.svelte';
import type {SvelteComponentConstructor} from 'core/types';


export const MULTIPLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<MultipleAcceptableValueEditorOptions<any>> = {
    acceptableValues: [],
    switchToInlineModeThreshold: 13,
    sortModel: false,
    showFirstCount: 0,
    reorderable: false,
    optionLabelComponent: DefaultOptionLabel as SvelteComponentConstructor<{option}>,
    optionIdResolver: ({option}) => option,
    sortComparator: undefined,
    optionDisabledResolver: () => false,
};

/**
 * @ngdoc constant
 * @name MULTIPLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.multiple-acceptable
 *
 * @description
 * ```
 * {
 *     description: '',
 *     allSelected: 'All selected',
 *     more: 'More',
 *     less: 'Less',
 *     selectAll: 'Select all',
 *     deselectAll: 'Deselect all'
 *     deselectOption: 'Deselect option',
 *     moveDown: 'Move down',
 *     moveUp: 'Move up',
 *     changeToCheckboxesMsg: 'Following input is custom multi select widget, probably not very accessible. Click on this button to change it to group of checkboxes.'
 * }
 * ```
 */
export const MULTIPLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<MultipleAcceptableValueEditorLocalizations>({
    description: '',
    allSelected: 'All selected',
    more: 'More',
    less: 'Less',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    deselectOption: 'Deselect option',
    moveDown: 'Move down',
    moveUp: 'Move up',
    changeToCheckboxesMsg: 'Following input is custom multi select widget, probably not very accessible. Click on this button to change it to group of checkboxes.'
});